import { IFeedType, CustomChannelSourceTypeEnum } from "../../interfaces";

export const isTwitter = (feedType: IFeedType | undefined) => {
  return (
    feedType && feedType.type === CustomChannelSourceTypeEnum.TWITTERACCOUNT
  );
};

export const isTwitterTag = (feedType: IFeedType | undefined) => {
  return feedType && feedType.type === CustomChannelSourceTypeEnum.TWITTERTAG;
};

export const isInstagramBusiness = (feedType: IFeedType | undefined) => {
  return (
    feedType &&
    feedType.type === CustomChannelSourceTypeEnum.INSTAGRAMBUSINESSBUSINESS
  );
};

export const isInstagramBusinessTag = (feedType: IFeedType | undefined) => {
  return (
    feedType &&
    feedType.type === CustomChannelSourceTypeEnum.INSTAGRAMBUSINESSTAG
  );
};

export const isFacebook = (feedType: IFeedType | undefined) => {
  return feedType && feedType.type === CustomChannelSourceTypeEnum.FACEBOOKPAGE;
};

export const isLinkedIn = (feedType: IFeedType | undefined) => {
  return feedType && feedType.type === CustomChannelSourceTypeEnum.LINKEDINPAGE;
};

export const isWebEx = (feedType: IFeedType | undefined) => {
  return feedType && feedType.type === CustomChannelSourceTypeEnum.WEBEXROOM;
};

export const isMicrosoftTeams = (feedType: IFeedType | undefined) => {
  return (
    feedType &&
    feedType.type === CustomChannelSourceTypeEnum.MICROSOFTTEAMSCHANNEL
  );
};
export const isYammer = (feedType: IFeedType | undefined) => {
  return (
    feedType && feedType.type === CustomChannelSourceTypeEnum.YAMMERCHANNEL
  );
};

// export const isZoom = (feedType: IFeedType | undefined) => {
//   return feedType && feedType.type === CustomChannelSourceTypeEnum.ZOOMROOM;
// };

export const isSlack = (feedType: IFeedType | undefined) => {
  return feedType && feedType.type === CustomChannelSourceTypeEnum.SLACKCHANNEL;
};

export const isWorkplace = (feedType: IFeedType | undefined) => {
  return (
    feedType && feedType.type === CustomChannelSourceTypeEnum.WORKPLACEGROUP
  );
};

export const isSharePoint = (feedType: IFeedType | undefined) => {
  return (
    feedType && feedType.type === "SHAREPOINTSITE" as CustomChannelSourceTypeEnum
  );
};

export const isPowerBI = (feedType: IFeedType | undefined) => {
  return feedType && feedType.type === "POWERBIDASHBOARD" as CustomChannelSourceTypeEnum;
};

export const isUrl = (source: any) => {
  return source.type === "URL"
}

export const getSourceLabel = (source: any) => {
  switch (true) {
    case isTwitter(source):
    case isTwitterTag(source):
      return source.user_name;
    case isWebEx(source):
      const hashtag = source.custom_fields.hashtag;
      return `${source.full_name}` + (hashtag ? ` (#${hashtag})` : "");
    case isSlack(source):
      // case isZoom(source):
      return source.custom_fields.name;
    case isSharePoint(source):
      return source.custom_fields.display_name
    case isPowerBI(source):
      return source.custom_fields.dashboard_name
    case isUrl(source):
      return source.custom_fields.url
    default:
      return source.full_name ?? "-";
  }
};
